import { Component, OnInit, Inject, ViewChild, TemplateRef } from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

import { ServicepoolService } from '../services/servicepool.service';

import { ReponseWebService } from '../datastruct/Meloyi.module';


export interface DialogData {
  assurName : string; 
  categs: any[];
  policy: boolean;
}


@Component({
  selector: 'app-selected-assurance',
  templateUrl: './selected-assurance.component.html',
  styleUrls: ['./selected-assurance.component.css']
})
export class SelectedAssuranceComponent implements OnInit {



  checkStatus = [] ;

  checkboxEditDeactivate = [] ;

  eltsType = [] ;

  saveBtnState = "done_all" ;

  primenameedit = "edit" ;

  baseElement = "" ;

  editprimename = 0 ;

  configPrimeBtn = false ;

  primeconfigObject : any ;

  baseConfigChoosen : any ;


  methodConfig = 1 ;

  eltName = "" ;

  allCategs = [] ;

  newCateg = "" ;

  Tabval = "";

  policy = false ;
 
  headClass = "card-header card-header-tabs card-header-primary" ;


  rowNumber = 0 ;
  resultArray = [] ;
  resultArrayConfigs  = [] ;
  subTabLength = 2 ;
  subTabConfigsLength = 1 ;

  lesConfigActuelles = [] ;

  nomAssurance = "" ;
  orignnomAssurance = "" ;

  infosup = "" ;

  typeassurance : any ;
  bigcategorie : any ; 


  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  spinnerDialogRef : any ;


  constructor(private dialogRef: MatDialogRef<SelectedAssuranceComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,public dialog: MatDialog,  private configServer: ServicepoolService ){ 
    this.eltName = data.assurName ;
    this.orignnomAssurance = this.formatThisString(data.assurName) ;
    this.policy = data.policy ;
    this.allCategs = data.categs ;
    this.infosup = data.infosup ;

    this.typeassurance = data.typeassurance ;
    this.bigcategorie = data.bigcategorie ;

    console.log(data) ;

  }


  ngOnInit(){
    var onChunkArray = [] ;
    var index = 0 ;
    this.resultArray = this.allCategs.reduce((indexDead, item ) => { 
    const chunkIndex = Math.floor(index/this.subTabLength)

    if(!onChunkArray[chunkIndex]) {
    onChunkArray[chunkIndex] = [] // start a new chunk
    }

    onChunkArray[chunkIndex].push(item) ;

    index++ ;

    return onChunkArray ;
    }, []) ;

    if(this.allCategs.length==1 && this.allCategs[0].nomFrmt=="AucuneDistinction"){
      this.checkStatus.push(true) ;
      this.checkboxEditDeactivate.push(false) ;
      this.eltsType.push([]) ;
    }
    else{
      for (var i = 0; i< this.allCategs.length; i++) {
        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        this.eltsType.push([]) ;
      }  
    }

  }


  getSameKindAssuranceTypeConfigs(){

    this.openSpinnerDialog();
    this.configServer.getSameKindAssuranceTypeConfigs("1111", this.typeassurance.intitule).then( (retourbi) => {
      this.closeSpinnerDialog() ;
      this.lesConfigActuelles = JSON.parse(retourbi.data) ;

      this.resultArrayConfigs = this.lesConfigActuelles ;

      /*
      var onChunkArray = [] ;
      var index = 0 ;
      this.resultArrayConfigs = this.lesConfigActuelles.reduce((indexDead, item ) => { 
      const chunkIndex = Math.floor(index/this.subTabConfigsLength)

      if(!onChunkArray[chunkIndex]) {
        onChunkArray[chunkIndex] = [] ;
      }

      onChunkArray[chunkIndex].push(item) ;

      index++ ;

      return onChunkArray ;
      }, []) ;    
      */


    }) ;            

  }



  onBtnClick(returnedValue): void {
    if(returnedValue=="-")
      this.dialogRef.close(returnedValue);
    else
      this.dialogRef.close(this.nomAssurance);
  }

  soppiMbirrMi(domaine){

    this.Tabval = (this.Tabval==this.eltName)? "-":this.eltName ;
  }

  editPrime(){
    if(this.editprimename==0){
      this.editprimename = 1 ;
      this.primenameedit = "done";      
    }else{

      this.nomAssurance = this.eltName ;

      if(this.orignnomAssurance!=""){
        var data = {"title": "Confirmation", "message": "Voulez-vous vraiment enregistrer cette Information ?"} ;
        const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {data});
        dialogRef1.afterClosed().subscribe(result => {
          console.log(result) ;
          if(result=="dlt"){
              this.configServer.updateNomAssurance(1, this.orignnomAssurance, this.formatThisString(this.nomAssurance), this.nomAssurance ).then( (retourbi) => {
                  var statutrec = retourbi.statutreq ;
                  var message = retourbi.message ;
                  console.log(retourbi) ;

                  if(statutrec==1){
                    this.orignnomAssurance = this.formatThisString(this.nomAssurance) ;
                    console.log("Done") ;
                  }
                  else
                    console.log("Failed") ;
              }) ;                      
          }
          else{
            console.log("") ;
          }
        });
      }else{

            let myAddedParts = {"typeassurance":this.typeassurance, "bigcategorie": this.bigcategorie} ;

            var theConfig = {"nomFrmt": this.formatThisString(this.nomAssurance), "intitule": this.nomAssurance, "policy": this.policy, "categs": this.allCategs } ;
            this.configServer.addNewConfig("111", JSON.stringify(theConfig), this.formatThisString(this.nomAssurance), this.infosup, myAddedParts ).then( (retourbi) => {
                var statutrec = retourbi.statutreq ;
                var message = retourbi.message ;
                console.log(retourbi) ;

                if(statutrec==1){
                  this.orignnomAssurance = this.formatThisString(this.nomAssurance) ;
                  console.log("Done") ;
                }
                else
                  console.log("Failed") ;
            }) ;                                    
      }

      this.editprimename = 0 ;
      this.primenameedit = "edit";            
    }
  }

  deletePrime(){
    var retourObjet = {"nomassurance": "*", "categs": this.allCategs, "policy": this.policy} ;

    var data = {"title": "Supprimer Assurance", "message": "Voulez-vous vraiment supprimer cette Configuration ?"} ;
    const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {data});
    
    dialogRef1.afterClosed().subscribe(result => {
      console.log(result) ;
      if(result=="dlt"){
        this.configServer.deleteAssurance(1, this.orignnomAssurance).then( (retourbi) => {
            var statutrec = retourbi.statutreq ;
            var message = retourbi.message ;
            if(statutrec==1){
              this.dialogRef.close(JSON.stringify(retourObjet));
              console.log("Done") ;
            }
            else{
              this.dialogRef.close(JSON.stringify(retourObjet));
              console.log("Failed") ;
            }
        }) ;        

      }
      else{
        console.log("") ;        
      }
    });
  }

  ajouterCateg(){
    if (this.newCateg != "" && this.saveBtnState=="done_all"){
      this.allCategs.push({"nomFrmt":this.formatThisString(this.newCateg), "intitule": this.newCateg, "garanties": []}) ;

      this.checkStatus.push(true) ;
      this.checkboxEditDeactivate.push(false) ;

      var onChunkArray = [] ;

      var index = 0 ;

      this.resultArray = this.allCategs.reduce((indexDead, item ) => { 
        const chunkIndex = Math.floor(index/this.subTabLength) ;

        if(!onChunkArray[chunkIndex]) {
          onChunkArray[chunkIndex] = [] ; 
        }

        onChunkArray[chunkIndex].push(item) ;
        index++ ;
        return onChunkArray ;
      }, []) ; 

      this.newCateg = "" ;
    }
  }

  onCategChoose(event, i, j) {
    if (event.target.checked){
      this.checkStatus[j+2*i]=true ;
      var typeIndex = j+2*i ;
    }
    else{
        console.log("UNCHECKED "+event.target.value) ;
        this.checkStatus[j+2*i]=false ;      
    }
    console.log(this.baseElement);  
  }

  savePrime(){
    if (this.saveBtnState=="done_all"){

      for (var i = 0; i< this.checkStatus.length; i++) {
        if(this.checkStatus[i] == false)
          this.allCategs.splice(i,1) ;
      }

      var retourObjet = {"nomassurance": this.nomAssurance, "categs": this.allCategs, "policy": this.policy} ;
      this.headClass = "card-header card-header-tabs card-header-danger" ;      
      this.saveBtnState = "edit" ; 
      this.configPrimeBtn = true ;
      this.dialogRef.close(JSON.stringify(retourObjet));

    }else{
      this.headClass = "card-header card-header-tabs card-header-primary" ;
      this.saveBtnState = "done_all" ;
      this.configPrimeBtn = false ;      
    }
  }

  callConfirmDialog(){

    var data = {"title": "Supprimer Assurance", "message": "Voulez-vous vraiment supprimer cette Prime ?"} ;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {data});
    
    dialogRef.afterClosed().subscribe(result => {
      console.log(result) ;
      if(result=="dlt"){
        return true ;
      }
      else{
        return false ;        
      }
    });
  }

  formatThisString(name){
    return name.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ;
  }


  setPolicy(){
      var data = {"title": "Confirmation", "message": "Voulez-vous restreindre l'utilisation de cette configuration à l'analyse  ?"} ;
      const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {data});
      dialogRef1.afterClosed().subscribe(result => {
        console.log(result) ;
        if(result=="dlt"){

            this.configServer.updatePolicy(1, this.formatThisString(this.orignnomAssurance), true ).then( (retourbi) => {
                console.log(retourbi) ;

                if(retourbi.statutreq==1){
                  this.policy = true ;
                  console.log("Done") ;
                }
                else
                  console.log("Failed") ;
            }) ;                      
        }
        else{
          this.policy = false ;
          console.log("") ;
        }
      });
  }

  releasePolicy(){
    var data = {"title": "Confirmation", "message": "Voulez-vous vraiment rendre cette configuration utilisable par les agences ?"} ;
    const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {data});
    dialogRef1.afterClosed().subscribe(result => {
      console.log(result) ;
      if(result=="dlt"){

          this.configServer.updatePolicy(1, this.formatThisString(this.orignnomAssurance), false ).then( (retourbi) => {
              console.log(retourbi) ;

              if(retourbi.statutreq==1){
                this.policy = false ;
                console.log("Done") ;
              }
              else
                console.log("Failed") ;
          }) ;                      
      }
      else{
        this.policy = true ;
        console.log("") ;
      }
    });
  }

  duplicateTheChoosenConfig(){
    console.log("Fiiila") ;

    this.baseConfigChoosen.idbigcategorie = this.bigcategorie.idcateg ;
    this.baseConfigChoosen.bigcategorie = this.bigcategorie.categorie ;

    this.baseConfigChoosen.idtypeassurance = this.typeassurance.raniee ;
    this.baseConfigChoosen.typeassurance = this.typeassurance.intitule ;

    this.baseConfigChoosen.nomassurance = this.eltName ;

    let laconfig  =JSON.parse(this.baseConfigChoosen.config) ;
    laconfig.intitule = this.eltName ;
    laconfig.nomFrmt = this.formatThisString(this.eltName) ;

    this.baseConfigChoosen.config = JSON.stringify(laconfig) ;

    this.baseConfigChoosen.idcompagnie = JSON.parse(this.infosup).idcompagnie ;
    this.baseConfigChoosen.nomcompagnie = JSON.parse(this.infosup).nomcompagnie ;

    this.openSpinnerDialog();
    this.configServer.duplicateThisConfig("1111", this.baseConfigChoosen).then( (retourbi) => {
      this.closeSpinnerDialog() ;
      this.dialogRef.close();
    }) ;            


  }


  taneBenMethodConfig(val){
    this.methodConfig = val ;

    if(val==2)
      this.getSameKindAssuranceTypeConfigs() ;
  }

  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }


}
